import { Box, Button, Grid2, Switch, Typography, FormControl, FormLabel } from "@mui/material";
import PhoneNumberInput from "Components/Common/PhoneNumberInput";
import OTPInput from "Components/Common/OTPInput";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as WhatsppIcon } from "Assets/Icons/Settings/WhatsappIcon.svg";
import { ReactComponent as NotificationIcon } from "Assets/Icons/Home/NotificationIcon.svg";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { sendOTP } from "Services/service";
import { verifyOTP } from "Slices/thunks";
import * as yup from "yup";


const ChangePhoneSection = ({ profileInfo = {} }) => {
  const dispatch = useDispatch();
  const [otp, setOtp] = useState('');
  const [tab, setTab] = useState(1);
  const [minMobileLength, setMinMobileLength] = useState(8);

  const { Common, Translation } = useSelector((state) => ({
    Common: state.Common.common || {},
    Translation: state.Translation.translation?.Settings || {},
  }));
 
  const Schema = useMemo(() => {
    return yup.object({
      DialCode: yup.string().required(Translation?.DialCodeRequired || "Dial code is required field."),
      CountryCodeID: yup.string().required(Translation?.CountryCodeRequired || "Country code is required field."),
      Mobile: yup.string().required(Translation?.PhoneNumberRequired || "Phone number is required field.")
        .min(minMobileLength, Translation?.ValidPhoneNumber?.replace('XXX', minMobileLength) || `Phone number should be at least ${minMobileLength} digits.`)

    });

  }, [Translation, minMobileLength]) 

  useEffect(() => {
    if (Object.keys(profileInfo).length) {
      const country = Common?.Country.find((item) => item.ID === profileInfo.CountryCodeID)
      setMinMobileLength(country?.NumbersLimit)
    }

  }, [profileInfo])

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    setErrors,
    touched,
    setFieldTouched,
    setFieldValue,
  } = useFormik({
    initialValues: profileInfo,
    enableReinitialize: true,
    onSubmit: async (data) => {
      console.log("data", data);
      try {
        await sendOTP({
          IsEmail: false,  
          Mobile: values.Mobile, 
          CountryCodeID: values.CountryCodeID,
          DialCode: values.DialCode
        })
        setTab(2);
      } catch (error) {
        console.log('error: ', error);
        if (error.status === 404) {
          setErrors({Mobile: Translation?.UserAlreadyExists || "User already exists."});
        } else {
          toast.error(Translation?.SomethingWentWrong);
        }
      }
    },
    validationSchema: Schema,
  });

  const handleVerifyOtp = async () => { 
    try {
      await dispatch(verifyOTP({
        IsEmail: false, 
        Mobile: values.Mobile, 
        CountryCodeID: values.CountryCodeID,
        DialCode: values.DialCode,
        OTP: otp
      })).unwrap();
      setOtp('');
      setTab(1)
      toast.success(Translation?.PhoneUpdatedSuccessfully)
    } catch (error) {
      console.log('error: ', error);
      if (error.status === 400) {
        toast.error(Translation?.OTPMismatch)
      } else {
        toast.error(Translation?.SomethingWentWrong);
      }
    }
  }

  return (
    <Grid2 size={6}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <Box display={"flex"} flexDirection={"column"} gap="15px">
          <Typography fontWeight={500} variant="title">
            {Translation?.UpdateMobileNumber}
          </Typography>
          <PhoneNumberInput
            label={Translation?.PhoneNumber}
            value={values.Mobile}
            dialCodeValue={values.CountryCodeID}
            min={minMobileLength}
            handleBlur={handleBlur}
            handleChange={handleChange}
            onBlur={() => setFieldTouched("DialCode", true)}
            onChange={(value) => {
              setFieldTouched("Mobile", true)
              setFieldValue("CountryCodeID", value?.ID)
              setFieldValue("DialCode", value?.DialCode)
              setMinMobileLength(value?.NumbersLimit)
            }}
            disabled={tab === 2}
            error={touched.Mobile && errors.Mobile && errors.Mobile}
          />
          {/* <Box
            sx={(theme) => ({
              background: theme.palette.background.default,
              padding: "16px",
            })}
          >
            <ul
              style={{
                padding: "0px",
                margin: "0px",
                paddingInlineStart: "16px",
                display: "flex",
                flexDirection: "column",
                gap: "5px",
              }}
            >
              <li>
                <Typography color="secondary.light">
                  {" "}
                  {Translation?.VerifyMobileNumber}{" "}
                </Typography>{" "}
              </li>
              <li>
                <Typography color="secondary.light">
                  {Translation?.GetWhatsAppNotification}
                </Typography>
              </li>
            </ul>
          </Box> */}

          { tab === 2 &&
            <FormControl fullWidth>
              <FormLabel color="secondary" required label>
                {Translation?.EnterOTP}
              </FormLabel>
              <OTPInput separator={<span>-</span>} value={otp} onChange={setOtp} length={6} />
            </FormControl>
          }

          { tab === 2 ?
            <Button
              type="button"
              variant="outlined"
              sx={{ width: "fit-content" }}
              onClick={handleVerifyOtp}
            >
              {Translation?.Update}
            </Button> :
            <Button
              type="submit"
              variant="outlined"
              sx={{ width: "fit-content" }}
              disabled={Object.keys(errors).length}
            >
              {Translation?.SendOTP}
            </Button>
          }

          {/* <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Box
              sx={{
                "& span, p": {
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                },
              }}
            >
              <Typography
                mb="8px"
                display={"flex"}
                variant="subtitle"
                fontWeight={500}
              >
                <PrimaryIcon icon={WhatsppIcon} height="24px" width="24px" />
                Allow WhatsApp Notification
              </Typography>
              <Typography variant="body2" color="secondary.light">
                Never miss out on important updates and reminders from us.
                <PrimaryIcon
                  icon={NotificationIcon}
                  height="18px"
                  width="18px"
                  fill={false}
                />
              </Typography>
            </Box>
            <Switch defaultChecked />
          </Box> */}
        </Box>
      </form>
    </Grid2>
  );
};

export default ChangePhoneSection;
